export default __webpack_public_path__ + "static/media/specification.49532bf3.svg";